import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { FormikProps } from 'formik';
import React from 'react';

import { WsTextField, WsTextFieldProps } from '../inputs/WsTextField';

export interface WsFormTextFieldProps extends WsTextFieldProps {
  id: string;
  formik: FormikProps<any>;
  onChange?: (...args: any[]) => void;
}

export const WsFormTextField = ({ formik, ...props }: WsFormTextFieldProps) => {
  return (
    <WsTextField
      value={formik.values[props.id] || ''}
      onChange={props.onChange ? props.onChange : formik?.handleChange}
      onBlur={formik?.handleBlur}
      error={formik.touched[props.id] && Boolean(formik.errors[props.id])}
      helperText={formik.touched[props.id] && formik.errors[props.id] ? (formik.errors[props.id] as string) : ''}
      {...props}
    />
  );
};
